<div class="cash-flow-widget" [class.cash-flow-widget--small]="size === 'small'"
    [class.cash-flow-widget--medium]="size === 'medium'" [class.cash-flow-widget--half]="size === 'half'"
    [class.cash-flow-widget--full]="size === 'full'">
    <!-- Header -->
    <div class="cash-flow-widget__header">
        <div class="cash-flow-widget__header-content">
            <div class="cash-flow-widget__title">{{ title }}</div>
            <ng-container *ngIf="isEditMode">
                <div (click)="toggleSizeDropdown(index, $event)" cdkOverlayOrigin #editTrigger="cdkOverlayOrigin"
                    class="ai-advice-widget__icon-container">
                    <div class="ai-advice-widget__icon">
                        <img src="assets/icons/widget/pencil.svg" alt="Edit">
                    </div>
                </div>
                <!-- Size Dropdown -->
                <app-widget-edit [editTrigger]="editTrigger" [index]="index" [activeDropdownIndex]="activeDropdownIndex"
                    [getAvailableSizes]="getAvailableSizes" [changeWidgetSize]="changeWidgetSize"
                    [removeWidget]="removeWidget" [toggleSizeDropdown]="toggleSizeDropdown">
                </app-widget-edit>
            </ng-container>
            <ng-container *ngIf="isAddMode">
                <img class="add-widget-btn-icon no-dark-filter" src="assets/icons/img_frame-1171275385.png"
                    alt="Settings" (click)="addWidget.emit(); $event.stopPropagation()" />
            </ng-container>
        </div>
    </div>

    <!-- Content -->
    <div class="cash-flow-widget__content">
        <!-- Flow Cards -->
        <div class="cash-flow-widget__flow-cards">
            <!-- Incoming Card -->
            <div class="cash-flow-widget__card">
                <div class="cash-flow-widget__card-header">
                    <div class="cash-flow-widget__card-label cash-flow-widget__card-label--incoming">Incoming</div>
                    <div class="cash-flow-widget__arrow cash-flow-widget__arrow--incoming">
                        <img class="cash-flow-widget__arrow-icon" src="assets/icons/arrow-down-thick.svg"
                            alt="Arrow Up">

                    </div>
                </div>
                <div class="cash-flow-widget__amount">{{ incomingAmount | currency:'INR':'symbol':'1.0-0' }}</div>
            </div>

            <!-- Outgoing Card -->
            <div class="cash-flow-widget__card">
                <div class="cash-flow-widget__card-header">
                    <div class="cash-flow-widget__card-label cash-flow-widget__card-label--outgoing">Outgoing</div>
                    <div class="cash-flow-widget__arrow cash-flow-widget__arrow--outgoing">
                        <img class="cash-flow-widget__arrow-icon" src="assets/icons/arrow-up-thick.svg"
                            alt="Arrow Down">
                    </div>
                </div>
                <div class="cash-flow-widget__amount">{{ outgoingAmount | currency:'INR':'symbol':'1.0-0' }}</div>
            </div>
        </div>

        <!-- AI Advice Section - Only for medium size -->
        <div class="cash-flow-widget__ai-section" *ngIf="size === 'medium' || size === 'full' || size === 'half'">
            <div class="cash-flow-widget__ai-icon">
                <img src="assets/icons/star-06.svg" alt="Star">
            </div>
            <div class="cash-flow-widget__ai-content">
                <div class="cash-flow-widget__ai-name">{{ aiName }}</div>
                <div class="cash-flow-widget__ai-message">{{ aiAdvice }}</div>
            </div>
            <button class="cash-flow-widget__chat-button">Chat</button>
        </div>
    </div>
</div>